






























import { Component, Vue } from 'vue-property-decorator'
import EventBus from '@/plugins/EventBus'
import { getSnackbarMessage } from '@/utils/common'
import { pushNotificationService } from '@/services/push-notification.service'

@Component({})
export default class NotificacaoPushPerfil extends Vue {
  isSubscribed = false
  loadingSubscription = false

  get isSupported() {
    return pushNotificationService.isSupported
  }

  get isBlocked() {
    return pushNotificationService.isBlocked
  }

  async mounted() {
    await this.loadSubscription()
  }

  async loadSubscription() {
    const subscription = await pushNotificationService.getSubscription()

    this.isSubscribed = !!subscription
  }

  async toggleSubscription(shouldSubscribe: boolean) {
    this.loadingSubscription = true

    const response = shouldSubscribe
      ? await pushNotificationService.subscribe()
      : await pushNotificationService.unsubscribe()

    this.loadingSubscription = false
    await this.loadSubscription()

    if (!response.success) {
      EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Não foi possível alterar as notificações deste dispositivo.', 'error'))
      return
    }

    const successMessage = shouldSubscribe
      ? 'Notificações ativadas neste dispositivo.'
      : 'Notificações desativadas neste dispositivo.'

    EventBus.$emit('setSnackbar', getSnackbarMessage(successMessage, 'success'))
  }
}
